/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 11:08:53                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-25 17:31:31                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
    * Components
  * TechniciansSection: dashboard technicians cards
    * useEffect - get technician times list
*/

/* Imports */
import { t } from "i18next";
/***/

/* Services */
import { api } from "../../../../../services/api/api";
import { resolveDashboardPeriod, toLocalDateTime } from "../../../dashboardPeriod";
import { selectDashboardUnavailabilities } from "./selectDashboardUnavailabilities";
/***/

/* Components */
import DashboardCardLayout from "../DashboardCardLayout";
import Loading from "../../../../../components/loading/Loading";
import UnavaibleTechDashCard from "../../../../../components/data/technician/UnavaibleTechDashCard";
import { useEffect, useState } from "react";
/***/

/**
* TechniciansSection: technicians unavailable today.
* Independent of the dashboard year/month filter, which would otherwise
* surface old paid leave ahead of a current sick leave.
*/
export default function TechniciansSection() {
  const [technicians, setTechnicians] = useState<EasyTech.Time[] | null>(null);
  const MAX_LENGTH = 3;

  /**
  * useEffect - absences that cover the current day
  */
  useEffect(() => {
    setTechnicians(null);
    const { from, to } = resolveDashboardPeriod("today");
    const fromParam = encodeURIComponent(toLocalDateTime(from));
    const toParam = encodeURIComponent(toLocalDateTime(to));

    api.get(`admin/technician_times/unavailable?from=${fromParam}&to=${toParam}`)
      .then(ret => setTechnicians(selectDashboardUnavailabilities(ret as EasyTech.Time[])))
      .catch(err => {
        console.error(err);
        setTechnicians([]);
      });
  }, []);
  /***/

  return(
    <div>
      <DashboardCardLayout  title={t("technician:titleUnavailable")}
                            max={technicians ? technicians.length : 0}
                            current={MAX_LENGTH}
                            path="/planning">
        <>
          {technicians ? 
            technicians.slice(0, MAX_LENGTH).map((el, index) => (
              <UnavaibleTechDashCard key={"tech-"+index} data={el}/>
            )) : <Loading/>}
        </>
      </DashboardCardLayout>
    </div>
  );  
}
/***/
